<mat-card-footer>
  <div class="balance-grand-total-bar">
    <span class="balance-grand-total-bar__label">{{ 'balance.review.grand-total-label' | translate }}</span>

    <span
      class="balance-grand-total-bar__amount balance-grand-total-bar__amount--patient patient-resp-amount"
      data-testid="grand-total-amount"
    >
      {{ totals.patientResp | currency }}
    </span>

    <ng-container *ngIf="totals.insuranceResp > 0; else insurancePlaceholder">
      <span
        class="balance-grand-total-bar__amount balance-grand-total-bar__amount--insurance"
        data-testid="grand-total-amount"
      >{{ totals.insuranceResp | currency }}</span>
    </ng-container>
    <ng-template #insurancePlaceholder>
      <span
        class="balance-grand-total-bar__amount balance-grand-total-bar__amount--insurance balance-grand-total-bar__amount--empty"
        data-testid="grand-total-amount"
      >—</span>
    </ng-template>

    <span
      class="balance-grand-total-bar__amount balance-grand-total-bar__amount--total"
      data-testid="grand-total-amount"
    >{{ totals.total | currency }}</span>
  </div>
</mat-card-footer>
